import {
  getFirestore,
  collection,
  addDoc,
  Timestamp,
} from "firebase/firestore";
import sendErrorDiscord from "./sendErrorDiscord.js"; // Assuming a custom log function similar to FlutterFlow
import { useState } from "react";
import { getDoc, doc } from "firebase/firestore";

const addLogDocument = async (
  url,
  prefix = "https://api.hexagone.expert/",
  userref,
  orgref,
  status,
  folderid,
  docid,
  request,
  response,
  type = "POST",
  delay = 0
) => {
  try {
    let start = new Date();
    const db = getFirestore(); // Initialize Firestore

    let email = "";
    if (orgref) {
      const orgSnapshot = await getDoc(orgref);
      email = orgSnapshot.get("email");
    }

    // Create the log document object
    const logDocument = {
      url: url,
      userref: userref ? userref : "",
      orgref: orgref ? orgref : "",
      type: type,
      email: email,
      status: status,
      date: Timestamp.now(), // Firestore timestamp
      folderid: folderid || "",
      docid: docid || "",
      request: request || "",
      response: response || "",
      resolved: false, // Default resolved state
      delay: delay,
    };

    // Send error to Discord if status is not 200

    if (
      status.toString() !== "200" &&
      prefix === "https://api.hexagone.expert/"
    ) {
      await sendErrorDiscord(
        `ERROR ${status} on endpoint: ${url}, response: ${response || ""}`,
        prefix
      );
      // Assuming you have an app state management system
      // FFAppState().error = true; can be translated to your React state management system
    }

    // Add the log document to the Firestore collection 'log'
    await addDoc(collection(db, "log"), logDocument);
    let end = new Date();
    let elapsed = end - start;
    return "Log document added successfully";
  } catch (error) {
    console.error("Error adding log document:", error);
    return `Error adding log document: ${error.message}`;
  }
};

export default addLogDocument;
